import React from "react";
import { FaLink } from "react-icons/fa6";
import { MdDeleteForever } from "react-icons/md";
import backendUrl from "../apiConfig";
import axios from "axios";

const LinkDisplay = React.memo(
  ({ isDarkMode, title, url, id, handleProfileChange, getLinks }) => {
    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(url);
        alert("Link copied to clipboard!");
      } catch (error) {
        console.error("Error copying to clipboard:", error);
      }
    };

    async function deleteLink(id) {
      const token = localStorage.getItem("jwtToken");
      try {
        const response = await axios.delete(
          `${backendUrl}/links/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          handleProfileChange();
          getLinks();
        }
      } catch (err) {
        console.error("Error deleting link:", err);
      }
    }

    return (
      <div
        className={`
          w-[95%] sm:w-[90%] mx-auto
          p-4 rounded-xl my-2
          ${isDarkMode ? "bg-gray-900 text-white" : "bg-white text-black"}
          shadow-sm hover:shadow-md transition-shadow duration-200
        `}
      >
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full">
          {/* Title and URL Container */}
          <div className="flex-1 min-w-0 space-y-1">
            <h3 className="text-lg sm:text-xl font-medium truncate">
              {title}
            </h3>
            <p className="text-sm sm:text-base text-gray-500 font-light truncate">
              {url}
            </p>
          </div>

          {/* Buttons Container */}
          <div className="flex gap-2 sm:gap-3 ml-auto">
            <button
              className={`
                p-2 sm:p-3 rounded-lg
                flex items-center justify-center
                hover:scale-105 active:scale-95
                transition-all duration-200
                ${isDarkMode 
                  ? "bg-white text-black hover:bg-gray-100" 
                  : "bg-black text-white hover:bg-gray-800"}
              `}
              onClick={copyToClipboard}
              aria-label="Copy link"
            >
              <FaLink className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>

            <button
              className={`
                p-2 sm:p-3 rounded-lg
                flex items-center justify-center
                hover:scale-105 active:scale-95
                transition-all duration-200
                ${isDarkMode 
                  ? "bg-white text-black hover:bg-gray-100" 
                  : "bg-black text-white hover:bg-gray-800"}
              `}
              onClick={() => deleteLink(id)}
              aria-label="Delete link"
            >
              <MdDeleteForever className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          </div>
        </div>
      </div>
    );
  }
);

// Add display name for React DevTools
LinkDisplay.displayName = 'LinkDisplay';

export default LinkDisplay;